import React from 'react';
import moment from 'moment';
import { Divider, Card, Row, Col, DatePicker, Spin } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { shouldUpdateCompare } from 'utils/utils2';
import Button from 'components/Button';
import Title from 'components/Title';
import ParListSelect from 'components/ParListSelect';
import ProposalSelect from 'components/ProposalSelect';
import JobResult from 'pages/Accounting/Components/JobResult';
import TaskInputByTaskTrigger from 'components/TaskInputByTaskTrigger';
import UtinaCard from 'components/UtinaCard';

const initialSearchParams: any = {
  ctridstart: 0,
  ctridend: 10000000,
  duedate: moment() as any,
  mode: 'RENTAL',
};

const FinContractEndOfTermReq = () => {
  const [form] = useForm();
  //   const [searchParams, setSearchParams] =
  //     useState<GenClientInvoiceByContractParams>(initialSearchParams);

  //   const onFinish = (values: GenClientInvoiceByContractParams) => {
  //     setSearchParams((prev) => ({
  //       ...prev,
  //       ...values,
  //       ctridend: form.getFieldValue('ctridend').ctrid ?? 10000000,
  //     }));
  //     setTimeout(refetch, 0);
  //   };

  //   const params = useMemo(
  //     () => ({ ...searchParams, duedate: dateToString(searchParams.duedate) }),
  //     [searchParams]
  //   );

  //   const {
  //     data: jobResponse,
  //     refetch,
  //     isFetching,
  //   } = useQuery(
  //     ['genClientInvoiceByContract', params],
  //     () =>
  //       genClientInvoiceByContract(params).then((res) => {
  //         notification.info({
  //           message: res.message,
  //           placement: 'bottomRight',
  //         });
  //         return res;
  //       }),
  //     {
  //       enabled: false,
  //     }
  //   );

  return (
    <DF.Provider pagcode="endoftermreq">
      <Spin spinning={false}>
        <Card
          title={<Title level={4} comcode="endoftermreq"></Title>}
          size="small"
        >
          <Form form={form} layout="vertical">
            <Row>
              <Col md={24}>
                <Row gutter={10}>
                  <Col md={20}>
                    <UtinaCard lg={19} comcode="endoftermreq" level={5}>
                      <Row gutter={10}>
                        <FormInput col xs={24} md={8} lg={8} name="ctridstart">
                          <ProposalSelect
                            onlyctrid
                            phase=""
                            PropOrProd="PROD"
                            onSelected={(e: any) => {
                              form.setFieldsValue({ ctridend: e });
                            }}
                          />
                        </FormInput>
                        <FormInput
                          col
                          xs={24}
                          md={8}
                          lg={6}
                          name="ctridend"
                          shouldUpdate={shouldUpdateCompare('ctridstart')}
                        >
                          <ProposalSelect
                            onlyctrid
                            phase=""
                            PropOrProd="PROD"
                            onSelected={(e: any) => {
                              form.setFieldsValue({ ctridend: e });
                            }}
                          />
                        </FormInput>
                        <FormInput col xs={24} md={8} lg={8} name="duedate">
                          <DatePicker showToday />
                        </FormInput>
                        <FormInput col xs={24} md={8} lg={8} name="ctendofterm">
                          <ParListSelect parcode="STATUSTERM" />
                        </FormInput>
                        <FormInput
                          col
                          xs={24}
                          md={8}
                          lg={8}
                          name="ctendoftermtaskid"
                        >
                          <TaskInputByTaskTrigger tasktrigger="ENDOFTERM" />
                        </FormInput>
                      </Row>
                    </UtinaCard>
                  </Col>

                  <Col
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Button
                      loading={false}
                      comcode="runservice"
                      type="primary"
                      htmlType="submit"
                      style={{ width: 200, marginLeft: 15, height: 60 }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col style={{ alignContent: 'center' }} xs={24}>
                {false && (
                  <Title level={3} type="danger" comcode="pleasewait" />
                )}
              </Col>
            </Row>
          </Form>
          <Divider></Divider>
          <UtinaCard comcode="result" level={5}>
            {false && <JobResult jobResponse={'' as any} />}
          </UtinaCard>
        </Card>
      </Spin>
    </DF.Provider>
  );
};

export default FinContractEndOfTermReq;
